/**
 * Used when neither the store nor this module has a language yet - a component
 * rendering before useLang has run. It is a last resort, not a default: the
 * store and getLanguage() are both checked first.
 */
export const FALLBACK_LANGUAGE = 'pt';

let language = null;

export const setLanguage = (value) => {
  language = value;
}

export const getLanguage = () => {
  return language;
}